/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { BackButton } from "../components/BackButton";
import ContactCard from "../components/ContactCard";
import { PageContainer } from "../components/layout/PageContainer";
import YesNoAction from "../components/YesNoAction";
import { selectContactInfo, selectUserContactDetails } from "../features/azure-b2c/storage";
import { selectSalesAgreementById } from "../features/sales-agreements/storage";
import { TestIds } from "../testIds";

export const DrawdownSuccess = () => {
  const params = useParams();

  const salesAgreementId = params.salesAgreementId;
  const salesAgreement = useSelector(selectSalesAgreementById(salesAgreementId));
  const contactDetail = useSelector(selectUserContactDetails);
  const navigate = useNavigate();

  const relationshipOwner = useSelector(selectContactInfo);

  if (!salesAgreement) {
    navigate("/agreements");
  }

  return (
    <PageContainer data-testid={TestIds.pages.drawdownSuccess}>
      <BackButton text="Back to Sales Agreement" onClick={() => navigate(-1)} />
      <YesNoAction
        display="Order Requested"
        subheading={
          <Typography variant="h4" sx={{ mt: 4, mb: 2 }}>
            Thanks {contactDetail?.firstName}!
          </Typography>
        }
        body={
          <>
            <Typography variant="body2">
              We have received your order and will send you an email confirmation before processing
              it.
              <br />
              <br />
              If any additional information is needed, we will reach out to you directly.
              <br />
              <br />
              Thank you for your purchase!
            </Typography>
            <br />
          </>
        }
      />
      <ContactCard
        sx={{ mt: 4 }}
        title="If you have any questions please contact your Farmlands representative."
        data-testid={TestIds.components.contactCard.card}
        {...relationshipOwner}
      />
    </PageContainer>
  );
};
